import React, { useState } from 'react';
import { InputNumber, Input, Button, Modal, Spin } from 'antd';
import { useNHIParamsForm } from './hooks/useNHIParamsForm';

const P9137Form: React.FC = () => {
  const {
    mode, isEditing, loading, records, current, currentIdx,
    salary, setSalary, empAmount, setEmpAmount, orgAmount, setOrgAmount,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete, quickSearch,
  } = useNHIParamsForm();

  const [searchText, setSearchText] = useState('');
  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除投保薪資 ${current.f937_01} 的等級資料？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: doDelete,
    });
  };
  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          健保參數建檔 (pw9137f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="投保薪資查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && quickSearch(searchText.trim())}
            disabled={isEditing} style={{ width: 150 }} />
          <Button onClick={() => searchText.trim() && quickSearch(searchText.trim())} disabled={isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || !records.length}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || !records.length}>&gt;|</Button>
        </div>
        <div className="space-y-4 mb-6">
          <div className="flex items-center gap-4">
            <label className="w-36 text-sm text-right">投保薪資 (F937_01)</label>
            <InputNumber value={salary} onChange={v => setSalary(v || 0)}
              disabled={mode !== 'add'} style={{ width: 150 }} min={0} max={999999} controls={false} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-36 text-sm text-right">被保人負擔 (F937_11)</label>
            <InputNumber value={empAmount} onChange={v => setEmpAmount(v || 0)}
              disabled={!isEditing} style={{ width: 150 }} min={0} max={99999} controls={false} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-36 text-sm text-right">投保單位負擔 (F937_21)</label>
            <InputNumber value={orgAmount} onChange={v => setOrgAmount(v || 0)}
              disabled={!isEditing} style={{ width: 150 }} min={0} max={99999} controls={false} />
          </div>
        </div>
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立者: {current.f937_91} | 建立日期: {current.f937_92 || '-'} | 修改者: {current.f937_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P9137Form;
